// Imports
import { cva } from "class-variance-authority";
import { Content, Container, ComponentWrapper } from "@/components";

// Styles
const TextContentAlignment = cva("w-full flex", {
  variants: {
    textAlignment: {
      left: "justify-start",
      center: "justify-center",
      right: "justify-end",
    },
  },
});

const TextContentWidth = cva("w-full", {
  variants: {
    width: {
      full: "max-w-full",
      lg: "max-w-6xl",
      md: "max-w-3xl",
      sm: "max-w-2xl",
    },
  },
});

// Text Content
export function TextContent({ type, content, textAlignment, width }) {
  // Render
  return (
    <ComponentWrapper type={type}>
      <Container>
        <div className={TextContentAlignment({ textAlignment })}>
          <div className={TextContentWidth({ width })}>
            <Content content={content} />
          </div>
        </div>
      </Container>
    </ComponentWrapper>
  );
}
